export default {
    inject: ['$validator'],
    props: {
        label: String,
        placeholder: String,
        value: [String,Number],
        required: Boolean,
        hideLabel: Boolean,
        readonly: Boolean
    },
    data() {
        return {
            name: "",
        }
    },
    computed: {
        validate() {
            return ((this.required) ? 'required|' : '') + this.rules;
        },
    },
    created() {
        this.name = Math.random().toString(36).replace(/[^a-z0-9]+/g, '').substr(2, 8)
    },
    methods: {
        inputValue(e) {
            this.$emit('input', e.target.value)
        },
    }
}


// WEBPACK FOOTER //
// ./src/mixins/mixinField.js